import { render, staticRenderFns } from "./ContentPage.vue?vue&type=template&id=31a1864a&scoped=true&"
import script from "./ContentPage.vue?vue&type=script&lang=ts&"
export * from "./ContentPage.vue?vue&type=script&lang=ts&"
import style0 from "./ContentPage.vue?vue&type=style&index=0&id=31a1864a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a1864a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
